import {
  Flex, Icon, Progress, Table, Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import axios from "axios";
// Custom components
import Card from "components/card/Card";
import { ASTRONAUTS } from "constants/Collection";
import { DaoStatus } from "constants/DaoStatus";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable
} from "react-table";
import SendPropositionModal from "./SendPropositionModal";
import ViewPropositionModal from "./ViewPropositionModal";

export default function ColumnsTable(props) {
  const { columnsData, tableData } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const { address } = useGetAccountInfo();
  const [nbAstronauts, setnbAstronauts] = useState();
  const isLoggedIn = Boolean(address);

  useEffect(async () => {
    if (isLoggedIn) {
      const response = await axios.get(`https://api.elrond.com/accounts/${address}/nfts?size=3000&collection=${ASTRONAUTS}`)
        .catch(e => console.error(e));
      const data = response?.data;
      setnbAstronauts(data.length);
    }
  }, [])

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 1000000;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px='25px' justify='space-between' mb='10px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          DAO Proposition
        </Text>
        <Text
          color={textColor}
          fontSize='16px'
          fontWeight='400'
          lineHeight='100%'>
          Voting power : {nbAstronauts || 0}
        </Text>
      </Flex>
      <Table {...getTableProps()} variant='simple' color='gray.500' mb='24px'>
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              <Th borderColor={borderColor}></Th>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe='10px'
                  key={index}
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color='gray.400'>
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                <Td
                  maxH='30px !important'
                  py='8px'
                  maxW={"25px"}
                  borderColor={borderColor}>
                  {data[index].status === "IN_PROGRESS" && <ViewPropositionModal nbAstronauts={nbAstronauts} setisMutating={props.setisMutating} data={data[index]} />}
                </Td>
                {row.cells.map((cell, cellIndex) => {
                  let data = "";
                  if (cell.column.Header === "NAME") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "STATUS") {
                    data = (
                      <Flex align="center">
                        <Icon
                          w="24px"
                          h="24px"
                          me="5px"
                          color={DaoStatus[cell.value].color}
                          as={DaoStatus[cell.value].icon}
                        />
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {new Date() > new Date(tableData[index].expiredAt)
                            ? "EXPIRED"
                            : DaoStatus[cell.value].text}
                        </Text>
                      </Flex>
                    );
                  } else if (cell.column.Header === "DATE") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {dayjs(new Date(cell.value)).format('DD MMM YYYY')}
                      </Text>
                    );
                  } else if (cell.column.Header === "PROGRESS") {
                    data = (
                      <Flex align='center'>
                        <Progress
                          variant='table'
                          backgroundColor={'#4143465e'}
                          colorScheme='brandScheme'
                          h='8px'
                          w='108px'
                          value={100 - ((dayjs(cell.value).diff(dayjs(), 'day', true)) * 100 / 33)}
                        />
                      </Flex>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={cellIndex}
                      fontSize={{ sm: "14px" }}
                      maxH='30px !important'
                      py='8px'
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor={borderColor}>
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Flex px='25px' justify='space-between' mb='10px' align='center'>
        {isLoggedIn && !!nbAstronauts && (
          <>
            <SendPropositionModal setisMutating={props.setisMutating} />
          </>
        )}
      </Flex>
    </Card>
  );
}
